import _inject from "@stylexjs/stylex/lib/stylex-inject";
function _toConsumableArray(r) {
  return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread();
}
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _iterableToArray(r) {
  if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
function _arrayWithoutHoles(r) {
  if (Array.isArray(r)) return _arrayLikeToArray(r);
}
function _slicedToArray(r, e) {
  return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}
function _arrayWithHoles(r) {
  if (Array.isArray(r)) return r;
}
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import SpinnerApple from "../ui/spinner/Spinner.Apple";
import * as stylex from "@stylexjs/stylex";
import Icon from "noood/comp/ui/feather-icon/Icon";
import { styling } from "noood/styles/styles.stylex";
import { colors } from "noood/styles/colors.stylex";
import Flex from "noood/comp/ui/containers/Flex";
export default function Button(props) {
  var _stylex$props;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    is_disabled = _useState2[0],
    set_is_disabled = _useState2[1];
  useEffect(function () {}, []);
  var classes = [];
  if (props.primary) {
    classes.push('filled');
  }
  if (props.classes) {
    classes = [].concat(_toConsumableArray(classes), _toConsumableArray(props.classes));
  }
  return /*#__PURE__*/React.createElement("button", {
    disabled: props.disabled,
    onClick: function onClick(evt) {
      if (!props.disabled) {
        var _props$__click;
        (_props$__click = props.__click) === null || _props$__click === void 0 || _props$__click.call(props, evt);
      }
    },
    className: [stylex.props(styling.button, ui.base, props.secondary && styling.buttonSecondary, props.big && ui.big, props.medium && ui.medium, props.negative && ui.negative, props.disabled && ui.disabled, props.small && ui.small, props.stylex).className, props.classes].join(' '),
    tabIndex: 1
  }, /*#__PURE__*/React.createElement(Flex, {
    gap: 5,
    alignItems: "center"
  }, props.loading && !props.rightIcon && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(SpinnerApple, null)), props.icon && !props.loading && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Icon, {
    icon: props.icon,
    color: props.disabled ? "var(--shade-10)" : "var(--text-on-accent)",
    className: [(_stylex$props = stylex.props(ui.icon, props.disabled && ui.disabledIcon)) === null || _stylex$props === void 0 ? void 0 : _stylex$props.className].join(' ')
  })), props.label && /*#__PURE__*/React.createElement("div", stylex.props(ui.label, props.disabled && ui.labelDisabled, props.small && ui.smallLabel), /*#__PURE__*/React.createElement("nobr", null, props.label)), props.rightIcon && !props.loading && /*#__PURE__*/React.createElement(Icon, {
    icon: props.rightIcon,
    color: props.disabled ? "var(--shade-10)" : "var(--text-on-accent)"
  }), props.loading && props.rightIcon && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(SpinnerApple, null))));
}
Button.propTypes = {
  __click: PropTypes.func,
  label: PropTypes.string,
  primary: PropTypes.bool,
  disabled: PropTypes.bool,
  classes: PropTypes.array,
  icon: PropTypes.string,
  loading: PropTypes.bool,
  style: PropTypes.object,
  small: PropTypes.bool,
  secondary: PropTypes.bool,
  zeroMargin: PropTypes.bool,
  big: PropTypes.bool,
  medium: PropTypes.bool,
  negative: PropTypes.bool,
  textStyle: PropTypes.object
};

// @ts-ignore
_inject(".evmz36l9{color:var(--evyiyotd)}", 3000);
_inject(".ev1lcnupm{color:var(--shade-10)}", 3000);
_inject(".ev1qhigcl{padding:20px}", 1000);
_inject(".ev1i1m3gp{font-size:22px}", 3000);
_inject(".ev6w2896{padding:15px}", 1000);
_inject(".ev1m36w8d{background-color:#ad3232}", 3000);
_inject(".ev152shbv:hover{background-color:#c03d3d}", 3130);
_inject(".evwc4cew:active{background-color:#a12b2b}", 3170);
_inject(".evfungia{color:#fff}", 3000);
_inject(".ev1y7ric0{background-color:var(--shade-05)}", 3000);
_inject(".ev1g19nhj{color:var(--shade-05)}", 3000);
_inject(".ev1tzx33q{color:var(--text-on-accent)}", 3000);
_inject(".ev160dt0k{font-family:font1}", 3000);
_inject(".ev1v9t41d{padding:4px 10px}", 1000);
_inject(".evif65rj{font-size:14px}", 3000);
var ui = {
  base: {
    "Button__ui.base": "Button__ui.base",
    $$css: true
  },
  icon: {
    "Button__ui.icon": "Button__ui.icon",
    color: "evmz36l9",
    $$css: true
  },
  disabledIcon: {
    "Button__ui.disabledIcon": "Button__ui.disabledIcon",
    color: "ev1lcnupm",
    $$css: true
  },
  big: {
    "Button__ui.big": "Button__ui.big",
    padding: "ev1qhigcl",
    paddingInline: null,
    paddingStart: null,
    paddingLeft: null,
    paddingEnd: null,
    paddingRight: null,
    paddingBlock: null,
    paddingTop: null,
    paddingBottom: null,
    fontSize: "ev1i1m3gp",
    $$css: true
  },
  medium: {
    "Button__ui.medium": "Button__ui.medium",
    padding: "ev6w2896",
    paddingInline: null,
    paddingStart: null,
    paddingLeft: null,
    paddingEnd: null,
    paddingRight: null,
    paddingBlock: null,
    paddingTop: null,
    paddingBottom: null,
    $$css: true
  },
  negative: {
    "Button__ui.negative": "Button__ui.negative",
    backgroundColor: "ev1m36w8d ev152shbv evwc4cew",
    color: "evfungia",
    $$css: true
  },
  disabled: {
    "Button__ui.disabled": "Button__ui.disabled",
    backgroundColor: "ev1y7ric0",
    color: "ev1g19nhj",
    $$css: true
  },
  label: {
    "Button__ui.label": "Button__ui.label",
    color: "ev1tzx33q",
    fontFamily: "ev160dt0k",
    $$css: true
  },
  labelDisabled: {
    "Button__ui.labelDisabled": "Button__ui.labelDisabled",
    color: "ev1lcnupm",
    $$css: true
  },
  small: {
    "Button__ui.small": "Button__ui.small",
    padding: "ev1v9t41d",
    paddingInline: null,
    paddingStart: null,
    paddingLeft: null,
    paddingEnd: null,
    paddingRight: null,
    paddingBlock: null,
    paddingTop: null,
    paddingBottom: null,
    $$css: true
  },
  smallLabel: {
    "Button__ui.smallLabel": "Button__ui.smallLabel",
    fontSize: "evif65rj",
    $$css: true
  }
};